import { enableProdMode } from '@angular/core';
import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from 'shared/environments/environment';
import { AppComponent } from '../../funnel/src/app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
